var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 15.9948C32.0038 24.8151 24.8215 32.0593 15.8726 31.9993C7.12704 31.9411 -0.0665022 24.7942 0.000463798 15.8662C0.0659147 7.12046 7.21248 -0.0713023 16.1405 0.000533526C24.8715 0.0708538 31.9987 7.1723 31.9999 15.9948ZM16.0141 30.1473C23.7955 30.1722 30.2139 23.7967 30.153 15.8863C30.0939 8.18072 23.7794 1.78734 15.8693 1.84796C8.16395 1.90676 1.76885 8.22528 1.84824 16.1557C1.9249 23.85 8.20788 30.1779 16.0141 30.1473Z",
    fill: "#363BC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5397 14.7471C14.5397 13.4098 14.5734 12.0713 14.527 10.7355C14.4994 9.93559 15.3664 9.44881 16.0845 9.8092C16.433 9.98409 16.616 10.2626 16.6151 10.6697C16.6099 13.1727 16.6136 15.6761 16.6096 18.1791C16.6093 18.3258 16.6432 18.4143 16.7842 18.4874C17.6714 18.946 18.5531 19.4155 19.4364 19.882C19.8915 20.1223 20.3473 20.3612 20.8 20.6058C21.2239 20.8346 21.4115 21.1914 21.3212 21.58C21.229 21.9767 20.8239 22.2853 20.3812 22.308C20.0879 22.3229 19.8303 22.2374 19.5743 22.0992C18.7574 21.6588 17.9332 21.2314 17.112 20.7986C16.4293 20.4385 15.7454 20.0805 15.0655 19.7156C14.7185 19.5292 14.5334 19.2482 14.5361 18.8353C14.5452 17.4723 14.5397 16.1095 14.5397 14.7471Z",
    fill: "#363BC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.5823bd8e3fe37d4ba6a66d7e052e2761.svg";
export { ForwardRef as ReactComponent };